import { axiosInstance, BASE_API_CONFIG } from "./Api";
import { lazyLoadScript } from "./helper";

export const RAZORPAY_CHECKOUR_URL =
  "https://checkout.razorpay.com/v1/checkout.js";

const razorpayConfigDefaults = {
  key: process.env.REACT_APP_RZP_KEY_ID,
  name: "MY EXIM BUSINESS",
  image: "https://myeximbusiness.com/favicon.ico",
};

console.log("razorpayConfigDefaults--->from the razorpay",razorpayConfigDefaults)


// export const getPaymentConfig = () => {
//      validateEnv();
//   if (!process.env.REACT_APP_RZP_KEY_ID) {
//     throw new Error('Razorpay key is not configured');
//   }
//   return {
//     rzpKey: process.env.REACT_APP_RZP_KEY_ID,
//   };
// };

// // src/utils/envValidation.js
// export const validateEnv = () => {
//   const requiredVars = [
//     'REACT_APP_API_BASE_URL',
//     'REACT_APP_RZP_KEY_ID',
//     'REACT_APP_ENV'
//   ];

//   requiredVars.forEach(varName => {
//     if (!process.env[varName]) {
//       throw new Error(`Missing required environment variable: ${varName}`);
//     }
//   });
// };



export const loadRazorpay = async () => {
  const isScriptLoaded = await lazyLoadScript(RAZORPAY_CHECKOUR_URL);

  if (!isScriptLoaded) {
    console.log("## Failed to load Razorpay!");
  }
};

export const createRazorpayOrder = async (amount, currencyCode, uuid) => {
  const payload = {
    amount: Number(amount),
    currency: currencyCode,
    uuid,
  };

  return axiosInstance
    .post(`${BASE_API_CONFIG.baseURL}/integrations/create-order`, payload)
    .then((response) => response.data);
};


export const initiateRazorpayCheckout = (
  order,
  userData,
  successHandler,
  errorHandler
) => {
  const checkoutOptions = {
    ...razorpayConfigDefaults,
    prefill: userData,
    description: "transaction description",
    amount: order.amount,
    currency: order.currency,
    order_id: order.id,
    handler: successHandler,
    
  };
  console.log("checkoutOptions", checkoutOptions);
  const razorPayInstance = new window.Razorpay(checkoutOptions);
  razorPayInstance.on("payment.failed", errorHandler);
  razorPayInstance.open();
};

export const verifyRazorpayPayment = async (
  orderId,
  paymentId,
  uuid,
  signature,
  pointsToAdd,
  errorReason,
) => {
  const payload = {
    orderId,
    paymentId,
    uuid,
    signature,
    pointsToAdd,
    errorReason: errorReason || "",
  };
   console.log("Verifying payment with payload:", payload);
  return axiosInstance
    .post(`${BASE_API_CONFIG.baseURL}/integrations/verify-payment`, payload)
    .then((response) => response.data)
    .catch((error) => error.response?.data || error.response);
};

export const createSubscriptionOrder = async (

  planId,
  priceAmount,
 
  currencyCode,
  baseName,
  isYearly,
  uuid,
  userId,
  email,
  
) => {
  return axiosInstance
    .post(`${BASE_API_CONFIG.baseURL}/subscription-plans/create-subscription-order`, {
      planId,
      priceAmount,
      currency: currencyCode,
      uuid,
      userId,
      email,
      baseName,
      isYearly,
    })
    .then((response) => response.data);
};

export const initiateSubscriptionCheckout = (
  order,
  userData,
  successHandler,
  errorHandler
) => {
  const checkoutOptions = {
    ...razorpayConfigDefaults,
    amount: order.amount,
    currency: order.currency,
    order_id: order.id,
    handler: successHandler,
    prefill: userData,
    notes: {
      planId: order.notes.planId,
      userId: order.notes.userId
    }
  };

  const rzp = new window.Razorpay(checkoutOptions);
  rzp.on("payment.failed", errorHandler);
  rzp.open();
};


export const verifyRazorpayPayments = async (
  orderId,
  paymentId,
  uuid,
  signature,
  errorReason
) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_API_CONFIG.baseURL}/subscription-plans/verify-payment`,
      {
        orderId,
        paymentId,
        uuid,
        signature,
        errorReason,
      }
    );
    console.log("Check Verifying Payment console",response.data)
    return response.data;
  } catch (error) {
    console.error('Payment verification failed:', error.response?.data || error.message);
    throw error;
  }
};
